<template>
  <div class="ide">
    <div
      class="nav-list"
      :class="{'narrow': !(navHeight >= maxNavHeight &&　navHeight　> 790)}"
      v-if="leftSideNavList.length">
      <div class="nav-warp">
        <div
          v-for="(item, index) in leftSideNavList"
          :class="{ actived: item.isActive }"
          :key="index"
          class="nav-item"
          @click="chooseLeftModule(item)"
          :title="item.name">
          <span
            :class="item.icon"
            class="nav-icon"/>
          <span
            v-if="navHeight >= maxNavHeight &&　navHeight　> 790"
            class="nav-name"
          >
            {{ item.name }}
          </span>
        </div>
      </div>
    </div>
    <we-panel
      class="container"
      diretion="horizontal">
      <we-panel-item
        v-if="leftModule"
        :index="1"
        :width="200"
        :min="200"
        :max="400"
        class="left-panel">
        <workSidebar v-if="leftModule.key === 'workSpace'"/>
        <hiveSidebar
          v-if="leftModule.key === 'database'"
          :node="node"
          :model="model"/>
        <fnSidebar
          v-if="leftModule.key === 'udfFunction'"
          type="udf"
          key="udf"
          :node="node"
          :model="model"/>
        <fnSidebar
          v-if="leftModule.key === 'methodFunction'"
          type="method"
          :node="node"
          key="method"
          :model="model"/>
        <hdfsSidebar v-if="leftModule.key === 'hdfs'"/>
      </we-panel-item>
      <we-panel-item
        :index="2"
        class="center-panel">
        <template slot-scope="props">
          <workbench
            :width="props.width"
            :parameters="parameters"
            :node="node"
            :otherNodeNames="otherNodeNames"
            :readonly="readonly"
            v-if="props.width"/>
        </template>
      </we-panel-item>
    </we-panel>
  </div>
</template>
<script>
import workbenchModule from '@dss/js/module/workbench';
import workSidebarModule from '@dss/js/module/workSidebar';
import fnSidebarModule from '@dss/js/module/fnSidebar';
import hiveSidebarModule from '@dss/js/module/hiveSidebar';
import hdfsSidebarModule from '@dss/js/module/hdfsSidebar';
import { NODETYPE } from '@dss/js/service/nodeType'
export default {
  components: {
    workbench: workbenchModule.component,
    workSidebar: workSidebarModule.component,
    fnSidebar: fnSidebarModule.component,
    hiveSidebar: hiveSidebarModule.component,
    hdfsSidebar: hdfsSidebarModule.component,
  },
  props: {
    parameters: {
      type: Object,
      default: () => {
        return {
          content: '',
          params: {},
        };
      },
    },
    node: Object,
    readonly: {
      type: Boolean,
      default: false,
    },
    otherNodeNames:Array
  },
  data() {
    return {
      leftSideNavList: [],
      leftModule: null,
      level: 0,
      navHeight: 0,
    };
  },
  computed: {
    maxNavHeight() {
      const navItemHeight = 115;
      return navItemHeight * this.leftSideNavList.length + 100;
    },
    model() {
      return this.node && (this.node.type.split('.')[1] || '');
    },
  },
  mounted() {
    this.init();
    console.log("$$$$ mounted ide component");
    // 监听窗口变化，获取浏览器宽高
    window.addEventListener('resize', this.resize);
    this.sendTrack([{ pageId: 16,  type: 'show' }]);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    init() {
      this.leftSideNavList = this.setLeftSideNavList();
      if (!this.node || (this.node.type !== NODETYPE.SHELL && this.node.type !== NODETYPE.COMMAND)) {
        this.chooseLeftModule(this.leftSideNavList[0]);
      }
      this.resize();
    },
    setLeftSideNavList() {
      const workSpace = { key: 'workSpace', name: this.$t('message.navList.workSpace'), isActive: false, icon: 'fi-project' };
      const database = { key: 'database', name: this.$t('message.navList.database'), isActive: false, icon: 'fi-hivedb' };
      const udfFunction = { key: 'udfFunction', name: this.$t('message.navList.udfFunction'), isActive: false, icon: 'fi-fx-udf' };
      const methodFunction = { key: 'methodFunction', name: this.$t('message.navList.methodFunction'), isActive: false, icon: 'fi-fx-method' };
      const hdfs = { key: 'hdfs', name: this.$t('message.navList.hdfs'), isActive: false, icon: 'fi-disk' };
      let menuList = [workSpace, database, udfFunction, methodFunction, hdfs];
      if (this.node) {
        if (this.node.type === NODETYPE.SHELL || this.node.type === NODETYPE.COMMAND) {
          menuList = [];
        } else {
          menuList = [database, udfFunction, methodFunction];
        }
      }
      return menuList;
    },
    chooseLeftModule(item) {
      if (this.leftModule && this.leftModule.key !== item.key) {
        this.leftModule.isActive = false;
      }
      item.isActive = !item.isActive;
      this.leftModule = item.isActive ? item : null;
      const buttonIds = {database:98,udfFunction:99,methodFunction:100};
      this.sendTrack([{ pageId: 16, buttonId: buttonIds[item.key], type: 'click' }]);
    },
    resize() {
      this.navHeight = window.innerHeight;
    },
    'IDE:saveNode'(args, node) {
      this.$emit('save', args, node);
    },
  },
};
</script>
<style lang="scss" src="./index.scss">
</style>
